import { createAction } from "redux-actions";
import { CONFIRM_LIST, SET_CONFIRM_ID, SET_OPEN_CONFIRM_NOTIFICATION } from "../constants/store";

export const setConfirmedIdAction = createAction(SET_CONFIRM_ID)
export const setListConfirmAction = createAction(CONFIRM_LIST)
export const setOpenConfirmNotificationAction = createAction(SET_OPEN_CONFIRM_NOTIFICATION)